<script>

	import { onMount } from 'svelte';
	import {setState, getState} from "../../../../stores.js";


	// Var navSelected binded with appState var on Dashboard.svelte
	export let navSelected = '';

	let companyName = null;
	var userName = null;
	var user = null;

	onMount(() => {

		user = localStorage.getItem('user');

		user =  JSON.parse(user);

		if(user.company == 'none'){
			companyName = '';
		}
		else{
			companyName = user.company + ' -';	
		}
			
		userName = user.firstName + ' ' + user.lastName;
	});

	




	function navItemSelected(e){

		var id = e.target.id;

		if(user.company == 'none' && (id != 3 && id != 0)){

			alert('Add or join a company!');
		} 
		else{
			navSelected = id;
			setState('appState',navSelected);	
		}
		
	}


</script>


	<div class="topContainer">
		<!-- <div class="companyLogo">
			
		</div> -->
		<div class="companyName">
			{companyName}  {userName}
		</div>
	</div>

	<div class="midContainer">
		<div class="appNavContainer">


			{#if navSelected == 0} <!-- Company Info  --> 

				<div class="appNavItemSelected" on:click={(e) => navItemSelected(e)} id="0">
					<i class="fa-solid fa-building"></i>
					Company Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="1">
					<i class="fa-solid fa-cubes-stacked"></i>
					Products
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="2">
					<i class="fa-solid fa-table"></i>
					Batch Data
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="3">
					<i class="fa-solid fa-user"></i>
					User Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="4">
					<i class="fa-solid fa-chart-simple"></i>
					Data Analysis
				</div>
				
			{:else if navSelected == 1} <!--Products --> 

				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="0">
					<i class="fa-solid fa-building"></i>
					Company Info
				</div>
				<div class="appNavItemSelected" on:click={(e) => navItemSelected(e)} id="1">
					<i class="fa-solid fa-cubes-stacked"></i>
					Products
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="2">
					<i class="fa-solid fa-table"></i>
					Batch Data
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="3">
					<i class="fa-solid fa-user"></i>
					User Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="4">
					<i class="fa-solid fa-chart-simple"></i>
					Data Analysis
				</div>

			{:else if navSelected == 2} <!--Batch Data -->

				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="0">
					<i class="fa-solid fa-building"></i>
					Company Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="1">
					<i class="fa-solid fa-cubes-stacked"></i>
					Products
				</div>
				<div class="appNavItemSelected" on:click={(e) => navItemSelected(e)} id="2">
					<i class="fa-solid fa-table"></i>
					Batch Data
				</div>
				<div class="appNavItem " on:click={(e) => navItemSelected(e)} id="3">
					<i class="fa-solid fa-user"></i>
					User Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="4">
					<i class="fa-solid fa-chart-simple"></i>
					Data Analysis
				</div>

			{:else if navSelected == 3}<!-- User Info  -->

				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="0">
					<i class="fa-solid fa-building"></i>
					Company Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="1">
					<i class="fa-solid fa-cubes-stacked"></i>
					Products
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="2">
					<i class="fa-solid fa-table"></i>
					Batch Data
				</div>
				<div class="appNavItemSelected" on:click={(e) => navItemSelected(e)} id="3">
					<i class="fa-solid fa-user"></i>
					User Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="4">
					<i class="fa-solid fa-chart-simple"></i>
					Data Analysis
				</div>
			{:else if navSelected == 4}<!--Data Analysis-->
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="0">
					<i class="fa-solid fa-building"></i>
					Company Info
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="1">
					<i class="fa-solid fa-cubes-stacked"></i>
					Products
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="2">
					<i class="fa-solid fa-table"></i>
					Batch Data
				</div>
				<div class="appNavItem" on:click={(e) => navItemSelected(e)} id="3">
					<i class="fa-solid fa-user"></i>
					User Info
				</div>
				<div class="appNavItemSelected" on:click={(e) => navItemSelected(e)} id="4">
					<i class="fa-solid fa-chart-simple"></i>
					Data Analysis
				</div>
			{:else}
				<div>Error</div>
			{/if}
			
			
		</div>
	</div>

	<div class="botContainer">
		
	</div>
	

<style>
	

	.firstColumn{
		width: 20%;
	}

	/*Top Container - Company Logo and Company Name*/

	.topContainer{
		width: 100%;
		height: 9%;
		/*box-shadow: 0rem 0.08rem black;*/
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 10%;

	}

	.companyName{
		width: 85%;
		height: 100%;
		font-weight: 900;
		font-size: 1.0416666666666667vw;
		color: black;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: flex-start;
		border-bottom-color: white;
		border-bottom-width: 1px;
		border-bottom-style: solid;
	}


	/*Mid Container - App Navigation*/

	.midContainer{
		width: 100%;
		height: 82%;
	}


	.appNavContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		margin-top: 10%;
	}

	.appNavItem{
		width: 85%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		color: white;
		opacity: 1;
		font-weight: 900;
		font-size: 1.0416666666666667vw;
		cursor: pointer;
	}

	.appNavItem:hover{
		color: var(--brand-accent);
	}


	.appNavItemSelected{
		width: 85%;
		height: 10%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		opacity: 1;
		font-weight: 900;
		color: var(--brand-accent);
		font-size: 1.0416666666666667vw;
		cursor: pointer;
	}

	.appNavItemSelected > i,  .appNavItem > i{
		margin-right: 5%;
	}
	/*Bot Container -*/

	.botContainer{
		width: 100%;
		height: 9%;
	}
</style>

